<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津利顺德大饭店有限公司</div>
                  <p class="p1">
                    始建于1863年，素有“华夏第一店”美称的天津利顺德大饭店，是中国荣膺“全国重点文物保护单位”和“中华老字号”两项桂冠的酒店企业，也是拥有专属博物馆和游船码头且挂牌“国家AAA级旅游景区”的特色酒店，以博物馆式的历史文化主题酒店在全球酒店业独树一帜。
                  </p>
                  <p class="p2">
                    从革命领袖孙中山、周恩来到美国前总统格兰特、胡佛，从末代皇帝溥仪到晚清重臣李鸿章，从历任民国大总统到各路军阀政客，从一代名将蔡锷、张学良到文化名流严复、梁启超，从科技精英詹天佑、侯德榜到教育名家严修、张伯苓，从十世班禅到京剧大师梅兰芳……数不胜数的中外名人都在利顺德留下踪迹和故事。
                    利顺德维多利亚中庭
                    饭店的152套豪华客房、中庭花园、至尊西餐厅、白金汉宴会厅、海维林酒吧等均采用维多利亚式装修风格，诠释着其悠久的历史特点。位于负一层的酒店专属博物馆，三千余件文物展品，无一不在讲述着饭店所跨越三个世纪的历史沧桑和鲜为人知的传奇故事。
                  </p>
                  <div class="img1">
                    <img src="@/assets/images/lsd1.jpg" alt="" height="450px" />
                  </div>
                  <p class="p2">
                    天津利顺德大饭店——是天津城市历史，乃至中国近代历史的缩影，是无限精致服务与本地风情的最完美结合。
                  </p>
                  <div class="img1">
                    <img src="@/assets/images/lsd2.jpg" alt="" height="450px" />
                  </div>
                  <p class="p2">天津利顺德大饭店：1863年开业，超百年历史、超五星欧式奢华性酒店，是国家重点文物保护单位。</p>
                   <p class="p2">客房：152间 餐饮：中餐厅Shui An,全天候 Majestic 咖啡厅,1863 以及餐厅维多利亚酒吧 ，奥哈拉英式酒吧 宴会厅：320平米的白金汉宴会厅、温莎厅、泰晤士厅以及四间多功能厅 服务设施：健身中心、酒店博物馆、商务中心、水疗SPA。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>